/**
 * Recursively scans state and serializes any HTMLCanvasElement instances
 * into data URL strings ("image/jpeg", 0.85).
 */
export function serializeCanvasInState(state: unknown): unknown {
  if (state === null || state === undefined) {
    return state;
  }

  if (typeof HTMLCanvasElement !== 'undefined' && state instanceof HTMLCanvasElement) {
    return state.toDataURL('image/jpeg', 0.85);
  }

  if (Array.isArray(state)) {
    return state.map((item) => serializeCanvasInState(item));
  }

  if (typeof state === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(state as Record<string, unknown>)) {
      result[key] = serializeCanvasInState(value);
    }
    return result;
  }

  return state;
}
